import type { Action } from 'redux';
import type { IAdLink, ILinkTemplateRecord } from '../../../../../../shared/types';
import NotificationActions from '../../../../main/actions/NotificationActions';
import { AdLinkCreatorService } from '../../../../main/services/AdLinkCreatorService/AdLinkCreatorService';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { AdLinkCreatorState } from '../types/ReducerTypes';

const CreateAdLink = new ReduxAsyncAction<
  'CREATE_AD_LINK',
  { adLink: AdLinkCreatorState; domain: string; selectedTemplate?: ILinkTemplateRecord },
  { createdAdLink: IAdLink }
>('CREATE_AD_LINK');

CreateAdLink.registerRequest(async ({ adLink, domain, selectedTemplate }): Promise<{ createdAdLink: IAdLink }> => {
  try {
    const payload = AdLinkCreatorService.getAdLinkPayload({ ...adLink, domain });
    const templateId = selectedTemplate?.id;
    const templatePath = templateId ? `/template/${templateId}` : '';

    const response = await dash_api.post(`/v1/linkhub/ad${templatePath}`, payload);

    return { createdAdLink: response.data };
  } catch (error) {
    NotificationActions.showNotification('Failed to create ad link.', 'error');
    throw error;
  }
});

export const CREATE_AD_LINK = CreateAdLink.actionNamespaceConstants;
export const createAdLink = CreateAdLink.request;

export type CreateAdLinkResponseAction = Action<typeof CREATE_AD_LINK.response> & {
  data: { createdAdLink: IAdLink };
};
